export default "__VITE_ASSET__CgZe_uxO__"